import {LocalStorage, getSearchParamFromUrl} from '@chekin/core';

const OVERRIDE_KEY = 'iv_auto_capture';

const TRUE_VALUES = ['on', 'true', '1', 'enabled'];
const FALSE_VALUES = ['off', 'false', '0', 'disabled'];

function parseToggle(value: string | null): boolean | null {
  if (!value) return null;
  const normalized = value.toLowerCase();
  if (TRUE_VALUES.includes(normalized)) return true;
  if (FALSE_VALUES.includes(normalized)) return false;
  return null;
}

function readOverride(): boolean | null {
  try {
    const fromUrl = parseToggle(getSearchParamFromUrl(OVERRIDE_KEY));
    if (fromUrl !== null) {
      LocalStorage.set(OVERRIDE_KEY, fromUrl ? 'on' : 'off');
      return fromUrl;
    }
    return parseToggle(LocalStorage.get<string>(OVERRIDE_KEY));
  } catch {
    return null;
  }
}

export function resolveAutoCapture(flagEnabled: boolean): boolean {
  return readOverride() ?? flagEnabled;
}
